export const WCAG_STYLE =
  'outline: 1px dashed #595959 !important; outline-offset: 2px; transition:none;';
export const WCAG_PREVIEW_FIXES_STYLE = `
  border: 1px solid #4D4D4D !important;
  &:hover{
    color: #000000 !important;
    background-color: #ffffff !important;
    border: 1px solid #000000 !important;
  }
  &:focus{
    color: #000000 !important;
    background-color: #ffffff !important;
    border: 1px solid #000000 !important;
`;
